import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const LandingScreen = () => {
  const [name, setName] = React.useState("")
  // const [nameData, setNameData] = React.useState("")
  const navigate = useNavigate()

  const addUser = () => {
    // setNameData(name);
    window.localStorage.setItem
    ("names", JSON.stringify
    (name));

    navigate("/hero")
  }

  // React.useEffect(() => {
  //   window.localStorage.setItem
  //   ("names", JSON.stringify
  //   (nameData))
  // }, [])

  return (
      <Container>

            <img style={{width:"120px"}} src="/taskImg.svg" alt="" />

            <h2>Welcome to Task Tracker</h2>
            <p>CREATE TASKS, AND KEEP TRACK..</p>
            <br />

            <div style={{backgroundColor:"#18399e", width:"100%", borderRadius:"30px 30px 0px 0px", height:"300px", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", position:"absolute", zIndex:"-0.3", bottom:"-45px"}}></div>

            <InputField placeholder="Please, enter your name"
              onChange={((e:any) => {
                setName(e.target.value)
              })}
             />

             {name !== "" ? <Button onClick={addUser} bg='black'>Let's Go</Button> 
              : 
             <Button disabled bg='silver'>Let's Go</Button> }

             <p style={{fontSize:"14px", color:"white", zIndex:"1"}}>Developed by CodeLab (E-ben)</p>

             
            
            
      </Container>
          
          
          
  )
};

export default LandingScreen;

// const Container = styled.div``;

// const Container = styled.div``;

// const Container = styled.div``;

// const Container = styled.div``;

// const Container = styled.div``;

// const Container = styled.div``;

// const Container = styled.div``;

const Button = styled.button<{bg: string}>`
height: 45px;
width: 250px;
margin-top: 20px;
border: none;
outline: none;
background-color: ${(props : any) => props.bg};
color: white;
border-radius: 20px;
transition: all 350ms;
cursor: Pointer;
font-weight: 600;
text-align: center;
z-index: 1;

:hover{
  transform: scale();
}
`;

const InputField = styled.input`
height: 40px;
width: 240px;
border: none;
padding-left: 10px;
border-radius: 5px;
outline-color: #dcd9f8;
box-shadow: 0 0 2px gray;
z-index: 1;
margin-top: 30px;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
height: 100vh;
position: relative;
overflow: hidden;

h2{
  font-size: 20px;
  color: #18399e;
}

p{
  font-weight: 600;
  color: #18399e;
}
`;

